<script setup lang="ts">
import { MoreVertical } from 'lucide-vue-next'
import { useElementalForm } from '../../ElementalFormContextProvider/context'
import Button from '~~/src/components/ui/button/Button.vue'
import ElementalMenu from '@/components/ElemetalMenu/index.vue'
import DropdownMenuTrigger from '~~/src/components/ui/dropdown-menu/DropdownMenuTrigger.vue'

const props = withDefaults(defineProps<{
  isListElement?: boolean
  showOpenAction?: boolean
  hiddeDuplicateAction?: boolean
  hiddeDeleteAction?: boolean
  hiddeCopyLinkAction?: boolean
  hiddeSaveAction?: boolean
  hiddeOpenExternalAction?: boolean
}>(), {
  showOpenAction: true,
})

const { elemental } = useElementalForm()
</script>

<template>
  <ClientOnly v-if="elemental?.id">
    <ElementalMenu v-bind="props" :elemental="elemental" :show-edit-action="false">
      <template #trigger>
        <DropdownMenuTrigger
          :as="Button"
          variant="snack-ghost"
          size="icon"
          type="button"
          class="rounded-full text-soft-black"
          @click.prevent.stop
        >
          <MoreVertical />
        </DropdownMenuTrigger>
      </template>
    </ElementalMenu>
  </ClientOnly>
</template>
